import { MovingDateValues } from '@/src/types/MoveOut';

export function formatMovingDate(movingDate?: MovingDateValues) {
  if (!movingDate) {
    return null;
  }

  const {
    date: { day, month, year },
  } = movingDate;

  return `${day}/${month}/${year}`;
}
